import React, { useRef } from 'react';
import Header from './Header';
import Hero from './Hero';
import Partnership from './Partnership';
import Results from './Results';
import ParallaxGallery from './ParallaxGallery';
import Comparison from './Comparison';
import PerformanceGuarantee from './PerformanceGuarantee';
import Branding from './Branding';
import Process from './Process';
import LeadMagnet from './LeadMagnet';
import EligibilityForm from './EligibilityForm';
import Footer from './Footer';

// Gallery images (moved from CompanyOverview)
const galleryImages = [
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/jq3y8i0b_1.jpg', alt: 'ACOE Property - Living Room' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/tznim1e2_2.jpg', alt: 'ACOE Property - Design Detail' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/ffznmaav_3.jpg', alt: 'ACOE Property - Bedroom' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/6d17kq0q_4.jpg', alt: 'ACOE Property - Lighting' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/23atw1ry_5.jpg', alt: 'ACOE Property - Interior' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/l84zzrlf_6.jpg', alt: 'ACOE Property - Room View' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/4ntz863h_7.jpg', alt: 'ACOE Property - Space Design' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/ey2mhvvb_8.jpg', alt: 'ACOE Property - Living Space' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/g5jln73e_9.jpg', alt: 'ACOE Property - Interior Detail' },
  { url: 'https://customer-assets.emergentagent.com/job_deployment-guide-11/artifacts/rgd4uuwz_10.jpg', alt: 'ACOE Property - Modern Design' }
];

const LandingPage = () => {
  const formRef = useRef(null);

  const scrollToForm = () => {
    const formElement = document.getElementById('contact');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Header onCtaClick={scrollToForm} />
      <Hero onCtaClick={scrollToForm} />
      <Partnership />
      <Results />
      {/* Photo Gallery - Now under ゲストからの声 */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <ParallaxGallery images={galleryImages} />
        </div>
      </section>
      <Comparison />
      {/* Swapped: Branding (ブランドの力) now comes before PerformanceGuarantee (成果保証制度) */}
      <Branding />
      <PerformanceGuarantee />
      <Process />
      <LeadMagnet />
      <EligibilityForm ref={formRef} />
      <Footer />
    </div>
  );
};

export default LandingPage;
